import React from 'react';
import { Text, screenXxsMax } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import SkeletonLoading, { Loading } from 'components/SkeletonLoading';

const Header = styled(Text)`
  ${Loading}
  width: 220px;
`;

// These values are manually configured to somewhat
// align with the english MessagingContainer
const StyledType = styled(Text)`
  ${Loading}
  min-height: 152px;

  @media (min-width: ${screenXxsMax}) {
    min-height: 104px;
  }
`;

const LoadingContainer = () => {
  return (
    <div data-testid="loading-container" aria-hidden="true">
      <Header forwardedAs="h1" variant="titleMedium" paddingBottom="0.75em">
        &nbsp;
      </Header>

      <StyledType forwardedAs="p" variant="bodyMedium" paddingBottom="1em">
        &nbsp;
      </StyledType>

      <SkeletonLoading width={170} height={48} />
    </div>
  );
};

export default LoadingContainer;
